import {connect} from 'react-redux';

import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {
  addCardGroupToCardAsyncAction,
  createCardGroupAsyncAction,
} from '../../../store/data/cardGroups/cardGroupsActions';
import {getUserNamespace} from '../../../store/data/teammates/teammatesSelectors';
import {CreateNewGroupPopover} from './createNewGroupPopover';

/*
 * Props.
 */

interface CreateNewGroupPopoverContainerProps {
  popoverProps: PopoverTransferProps;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CreateNewGroupPopoverContainerProps>()(() => ({
  userNamespace: getUserNamespace,
}));

const mapDispatchToProps = makeMapDispatchToProps<CreateNewGroupPopoverContainerProps>()(() => ({
  createCardGroupAsync: createCardGroupAsyncAction,
  addCardToGroupAsync: addCardGroupToCardAsyncAction,
}));

export const CreateNewGroupPopoverContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateNewGroupPopover);
